<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="custom">
          <jm-toolbar
            :hidden="fieldName !== 'student'"
            customize-field-name="student"
            show-defined-list
            size="small">
          </jm-toolbar>
          <jm-toolbar
            :hidden="fieldName !== 'TrainingCustomer'"
            customize-field-name="TrainingCustomer"
            show-defined-list
            size="small">
          </jm-toolbar>
          <jm-toolbar
            :hidden="fieldName !== 'JobMember'"
            customize-field-name="JobMember"
            show-defined-list
            size="small">
          </jm-toolbar>
        </div>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>渠道转移工具</span>
          </div>
          <el-form label-width="6em" :inline="true">
            <el-form-item label="切换列表">
              <el-select @change="handleSiteChange" v-model="site">
                <el-option label="蓝火" value="fib" />
                <el-option label="求职" value="job" />
                <el-option label="考培" value="training" />
                <el-option label="蓝火资源记录" value="snapshot_fib" />
                <el-option label="求职资源记录" value="snapshot_job" />
                <el-option label="考培资源记录" value="snapshot_training" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-form ref="searchForm" label-width="6em" :inline="true" :model="searchData">
            <el-form-item prop="id" label="客户编码">
              <el-row>
                <el-col :span="17">
                  <el-input clearable placeholder="多个用半角逗号分隔" v-model="searchData.id"></el-input>
                </el-col>
                <el-col :span="6" :offset="1">
                  <el-checkbox
                    v-model="searchData.id_not"
                    :label="'排除'"
                    name="id_not"
                    :value="1"
                  />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item prop="channel" label="渠道">
              <jm-channel
                v-model="searchData.channel"
                clearable
                filterable
              />
            </el-form-item>
            <el-form-item prop="custom_final_from" label="渠道号">
              <el-input type="number" placeholder="填此项将忽略选择的渠道" clearable v-model="searchData.custom_final_from"></el-input>
            </el-form-item>
            <el-form-item prop="nickname" label="昵称">
              <el-input clearable @change="handleNicknameChanged" v-model="searchData.nickname"></el-input>
            </el-form-item>
            <el-form-item v-if="site === 'fib'" prop="ct_custom_active_countries" label="办理国家">
              <el-select
                multiple
                clearable
                v-model="searchData.ct_custom_active_countries">
                <el-option
                  v-for="item in countries"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item prop="ct_create_person" label="创建人">
              <el-col :span="17">
                <el-select
                  v-model="searchData.ct_create_person"
                  multiple
                  filterable
                  clearable
                >
                  <el-option-group label="推广人">
                    <el-option
                      v-for="item in createPeople"
                      :key="`${-item.userid}`"
                      :label="`${item.username}`"
                      :value="item.userid"
                    />
                  </el-option-group>
                  <el-option-group label="采集功能">
                    <el-option
                      v-for="item in onlineCreators"
                      :key="`${-item.userid}`"
                      :label="`${item.username}`"
                      :value="item.userid"
                    />
                  </el-option-group>
                </el-select>
              </el-col>
              <el-col :span="6" :offset="1">
                <el-checkbox
                  v-model="searchData.ct_create_person_not"
                  :label="'排除'"
                  name="ct_create_person_not"
                  :value="1"
                />
              </el-col>
            </el-form-item>
            <el-form-item prop="creationDate" label="创建时间">
              <el-date-picker
                :editable="false"
                clearable
                v-model="searchData.creationDate"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                class="jm-input280"
                @change="handleCreationDateChanged"
              />
            </el-form-item>
            <div class="searchBottom">
              <el-form-item>
                <el-button
                  class="jm-input-common3"
                  type="primary"
                  :loading="fetching"
                  @click="sendForm">筛选</el-button>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="jm-input-common3"
                  type="default"
                  @click="resetForm">重置</el-button>
              </el-form-item>
            </div>
          </el-form>

          <!-- <div class="basic-title"><em>导入到渠道</em></div> -->
          <el-form label-width="6em" :inline="true" style="background-color:#f5f5f5;padding-top:20px;margin-bottom:15px">
            <el-form-item label="渠道">
              <jm-channel
                v-model="importChannels"
                clearable
                filterable
              />
            </el-form-item>
            <el-form-item label="渠道号">
              <el-input type="number" placeholder="填此项将忽略选择的渠道" clearable v-model="importChannel"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                class="jm-input135"
                type="danger"
                :loading="exporting"
                @click="handleImport">导入</el-button>
            </el-form-item>
          </el-form>

          <jm-tableList
            :url="url"
            :refresh.sync="fetching"
            :search-data="searchData"
            class="adminList"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              slot="firstColumn"
              type="selection" />

            <el-table-column
              slot="custom_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="custom_name">
              <template slot-scope="scope">
                <i
                  class="name-tip-l"
                  title="芥末注册用户"
                  v-if="scope.row.userid > 0"/>
                <el-tag
                  v-for="link in scope.row.link_others"
                  :key="link.id"
                  type="gray"
                >{{ getSiteTagByType(link.sync_type) }}</el-tag>
                <el-tooltip
                  v-if="isFibSite"
                  :disabled="!scope.row.crm_memo"
                  effect="dark"
                  :content="scope.row.crm_memo"
                  placement="top-start">
                  <router-link
                    v-if="!scope.row.is_other"
                    target="_blank"
                    :to="{ name: 'editStudent', params: { id: scope.row.id } }">
                    {{ scope.row.custom_name }} {{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}
                  </router-link>
                </el-tooltip>
                <span v-else>
                  {{ scope.row.custom_name }} {{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}
                </span>
                <span v-if="scope.row.is_other">
                  {{ scope.row.custom_name }} {{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}
                </span>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { jmChannel } from '@/components/tool';
import { mapGetters } from 'vuex';
import student from '@/pages/student/student';
import jmTableList from '@/components/data/tableList';
import jmToolbar from '@/components/tool/toolbar';
import { getSiteTagByType } from '@/utils/utils';

const channelFromMap = [
  'custom_from',
  'custom_from_sub',
  'custom_from_thrid',
  'custom_from_fourth',
  'custom_from_fifth',
];

const fieldNames = {
  fib: 'student',
  training: 'TrainingCustomer',
  job: 'JobMember'
};

const siteFetchUrls = {
  fib: '/index/student/pagetable',
  training: '/training/customer/pagetable',
  job: '/job/member/pagetable',
  snapshot_fib: '/index/student/snapshotPagetable',
  snapshot_job: '/job/member/snapshotPagetable',
  snapshot_training: '/training/customer/getPaginate'
};

export default {
  components: { jmChannel, jmTableList, jmToolbar },
  mixins: [student],
  data () {
    return {
      exporting: false,
      fetching: false,
      url: '/index/student/pagetable',
      ids: [],
      createPeople: [],
      onlineCreators: [],
      searchData: {
        showIgnore: true
      },
      importChannels: {},
      importChannel: null,
      site: 'fib',
      fieldName: 'student'
    };
  },
  computed: {
    ...mapGetters([
      'onlineDict',
    ]),
    countries() {
      return this.onlineDict.country;
    }
  },
  created() {
    this.getDatasource();
    this.searchDict();
  },
  methods: {
    sendForm () {
      this.fetching = true;
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      delete this.searchData.creationDate;
      this.searchData.id_not = false;
      this.searchData.ct_create_person_not = false;
      this.searchData.channel = {
        custom_from: '',
        custom_from_sub: '',
        custom_from_thrid: '',
        custom_from_fourth: '',
        custom_from_fifth: ''
      };
    },
    async handleImport () {
      this.exporting = true;
      let customFinalFrom = this.importChannel;
      !customFinalFrom && channelFromMap.forEach((key) => {
        if (this.importChannels[key] && this.importChannels[key] !== '') {
          customFinalFrom = this.importChannels[key];
        }
      });
      if (customFinalFrom && this.ids.length > 0) {
        try {
          await this.$confirm('您确定要这样做吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
          await this.$http._post({
            url: '/training/channel/batchImportUserTochannel',
            data: {
              ids: this.ids,
              customFinalFrom,
              site: this.site
            }
          });
          this.fetching = true;
          this.exporting = false;
          this.$message.success('导入成功');
        } catch (e) {
          this.exporting = false;
          return false;
        }
      } else {
        this.$message.error('缺少导入渠道所需的条件');
        this.fetching = false;
      }
    },
    handleSelectionChange (row) {
      const rowArr = [];
      row.forEach((item) => {
        rowArr.push(item.id);
      });
      this.ids = rowArr;
    },
    handleSiteChange (value) {
      this.url = siteFetchUrls[value];
      this.fieldName = fieldNames[value];
      this.resetForm();
      this.sendForm();
    },
    handleCreationDateChanged (value) {
      if (!value) {
        delete this.searchData.creationDate;
      }
    },
    async searchDict () {
      const { data } = await this.$http._post({
        url: '/index/system/searchDict'
      });
      this.createPeople = data.create_person;
      this.onlineCreators = data.online_creator;
    },
    handleNicknameChanged (value) {
      this.searchData.ct_name = value;
    },
    getSiteTagByType
  },
  watch: {
    searchData: {
      handler (value) {
        this.searchData = value;
      },
      deep: true
    }
  }
};
</script>
